var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-picker',{staticClass:"fontbox",attrs:{"api-key":"AIzaSyAfACkJIB_16bE-RF4ugOnqs8fzRhDAIyc","active-font":_vm.value},on:{"change":_vm.updateFont}})}
var staticRenderFns = []

export { render, staticRenderFns }